import Model from 'model-fns';
import Store from 'pull-store';
var model = Model('encoderID');
import Ev from '../../lib/event';

function PersistentStreams () {
    return model();
}

PersistentStreams.store = Store(function (state, ev) {
    return model.update[Ev.type(ev)](state, Ev.data(ev));
}, PersistentStreams())

export default PersistentStreams;